import { jsx as a } from "react/jsx-runtime";
import { forwardRef as i, useContext as g } from "react";
import { Badge as d, BadgeContext as f } from "../badge/Badge.js";
import { twMerge as m } from "tailwind-merge";
const n = i(
  ({ className: t, onClose: o, size: r, ...s }, e) => /* @__PURE__ */ a(
    d,
    {
      ref: e,
      className: m("justify-between bg-white ring-1 ring-gray-300", t),
      onClose: o,
      size: r,
      variant: "rounded",
      ...s
    }
  )
);
n.displayName = "Tag";
const l = i(
  ({ className: t, onClose: o, ...r }, s) => {
    const { size: e } = g(f);
    return /* @__PURE__ */ a(
      "div",
      {
        ref: s,
        className: m(
          "flex items-center justify-center rounded-sm bg-gray-100 text-xs font-medium text-gray-700",
          //
          e === "sm" && "size-4",
          e === "md" && "size-[18px]",
          e === "lg" && "size-5 text-sm",
          //
          t
        ),
        ...r
      }
    );
  }
);
n.displayName = "Tag";
export {
  n as Tag,
  l as TagCount
};
